import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useRunEmailExecTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (job: Api.IEmailExecBriefSystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (templateId: string) => {
			return userSession.webServiceHelper.callAsync<Api.IEmailExecBriefSystemJob>(
				`emailExecAssistant/templates/${templateId}/run`,
				'POST',
				{}
			);
		},
		onError,
		onSuccess,
	});
}
